export const AUDITORY_MODEL = {
  paso: 1,
  pasoDescripcion: "PASO_COTIZACION",
};

export const PLANS_MODEL = {
  paymentFrequencies: [
    "Mensual",
    "Semestral",
    "Anual",
  ],

  currencyOptions: [
    { text: "Soles", value: "SOL" },
    { text: "Dólares", value: "USD" },
  ],
  
  errorStep: "/comprar/seguro-vida-endoso-con-devolucion/error",
  graciasValidacionStep:
    "/comprar/seguro-vida-endoso-con-devolucion/gracias-validacion",
  suscripcionStep: "/comprar/seguro-vida-endoso-con-devolucion/declaracion-jurada",
  nextStep: "/comprar/seguro-vida-endoso-con-devolucion/direccion",
  urlHome: "/comprar/seguro-vida-endoso-con-devolucion",
};

export const QUESTION_MODEL = {
  questions: [
    {
      question: "¿Qué es el seguro de desgravamen?",
      answer:
        "Los seguros de desgravamen en productos distintos a los créditos hipotecarios para vivienda son de carácter opcional. Su función es saldar tu deuda con el banco en caso fallezcas o quedes con invalidez total y permanente, evitando que tus familiares deban asumir esa carga económica. El pago de este seguro ya está incluido en las cuotas mensuales del préstamo.",
    },
    {
      question: "¿Qué recupero exactamente?",
      answer:
        "Si cumples la vigencia, recibes el dinero aportado más el porcentaje de ganancia que elegiste al contratar. En caso de fallecimiento, el seguro paga primero tu deuda al banco. Si queda saldo a favor, tu familia lo recibe.",
    },
    {
      question:
        "¿Con qué bancos y créditos puedo usar este seguro endosable con devolución? ",
      answer:
        "Este seguro aplica para préstamos personales, vehiculares o hipotecarios en soles o dólares, con montos hasta S/600,000 o $160,000 y plazos entre 5 y 30 años. Actualmente, puedes usarlo con créditos en los siguientes bancos: BCP, Interbank, Scotiabank, BanBif, Pichincha y GNB.",
    },
    {
      question: "¿Cómo reemplazo mi seguro de desgravamen por uno endosable?",
      answer:
        "Al contratar tu seguro de vida endosable, recibirás por correo la póliza, carta de endoso y comprobante de pago. Debes presentar estos documentos al banco para que realicen el cambio de seguro en tu préstamo. No se te cobrará ninguna comisión adicional por el proceso.",
    },
    {
      question: "¿Qué debo tener en cuenta al contratar este seguro?",
      answer:
        "Debes asegurarte de que la suma asegurada y el plazo del seguro sean iguales o mayores al monto y duración de tu préstamo. Por ejemplo, si tu crédito es de S/195,000 por 15 años, tu seguro debe ser de al menos S/200,000 y por el mismo plazo. Además, ten a la mano el cronograma de pagos para facilitar el proceso.",
    },
    {
      question: "¿Qué sucede si tengo un préstamo mancomunado?",
      answer:
        "Si tu préstamo es mancomunado, cada titular debe contratar su propio seguro de vida endosable con devolución. Esto es un requisito que solicitan las entidades financieras para aceptar el endoso.",
    },
  ],
};
